// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3T_fV","buttons":"PendingPaymentAlert_buttons__1eW0N"};